import { createTheme, Theme } from '@mui/material/styles';

/**
 * Paletas MUI para os componentes que usam essa biblioteca (Avisos,
 * Relatórios). A cor de marca (vermelho) e as cores de prioridade/status
 * são mantidas IDÊNTICAS nos dois modos — só fundo/superfície/texto mudam,
 * conforme pedido: nunca alterar a cor dos botões e badges, só garantir que
 * o texto continue legível no fundo escuro.
 */
const CORES_MARCA = {
  primary: { main: '#e10600' },
  success: { main: '#2e7d32' },
  error: { main: '#c62828' },
  warning: { main: '#f9a825' },
  info: { main: '#0277bd' },
};

export function criarTemaMui(tema: 'claro' | 'escuro'): Theme {
  return createTheme({
    palette: {
      mode: tema === 'escuro' ? 'dark' : 'light',
      ...CORES_MARCA,
      ...(tema === 'escuro'
        ? {
            background: {
              default: '#121212',
              paper: '#1e1e1e',
            },
            text: {
              primary: '#f5f5f5',
              secondary: '#c7c7c7',
            },
          }
        : {}),
    },
    // Mesma fonte usada no restante do app (Tailwind) — antes as telas com
    // MUI (Avisos, Relatórios) caíam na fonte padrão do MUI (Roboto/sistema,
    // nem carregada no site), destoando visualmente do resto do produto.
    typography: {
      fontFamily: "'Inter', sans-serif",
    },
    // Alinhado ao raio de borda usado no Tailwind (rounded-md/rounded-lg)
    // para que cards e botões MUI combinem com os componentes Tailwind.
    shape: {
      borderRadius: 8,
    },
    components: {
      MuiPaper: {
        styleOverrides: {
          root: {
            // Mesma sombra sutil usada nos cards Tailwind (shadow-card),
            // em vez da sombra padrão mais pesada do Material Design.
            boxShadow: '0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24)',
          },
        },
      },
      MuiButton: {
        styleOverrides: {
          root: {
            textTransform: 'none',
            fontWeight: 600,
          },
        },
      },
    },
  });
}
